import styled from 'styled-components'

export const StyledLocationDetail = styled.article`
  margin-bottom: 40px;
  & > header {
    display: flex;
    justify-content: baseline;
  }
  & > h2,
  & > header > h2 {
    margin-bottom: 16px;
  }
  & > h2 + p,
  & > header + p {
    margin-bottom: 16px;
  }
  & > section {
    display: flex;
    article {
      flex: 1;
    }
    p + p {
      margin-top: 8px;
    }
    p span {
      padding-left: 8px;
    }
  }
  & > footer {
    margin-top: 24px;
  }
`
